import { MaybeStringOrNumber } from '../utils'
import {
  CommonLabelProps,
  LabeledItem,
  StyledTextOrTranslation,
  TextOrTranslationProps
} from '.'

interface TextContentProps extends TextOrTranslationProps {
  id?: string
}

const TextContent = ({ id, ...rest }: TextContentProps) => {
  return (
    <StyledTextOrTranslation
      {...rest}
      typographyProps={{ id, variant: 'body2' }}
    />
  )
}

interface LabeledTextProps extends CommonLabelProps {
  defaultText?: string
  defaultTranslationId?: string
  id?: string
  texts?: MaybeStringOrNumber[]
  textTranslationIds?: string[]
}

export const LabeledText = ({
  defaultText,
  defaultTranslationId,
  id,
  texts,
  textTranslationIds,
  ...labelProps
}: LabeledTextProps) => {
  const hasTexts = texts !== undefined || textTranslationIds !== undefined

  const defaultTextContent = !hasTexts && (
    <TextContent text={defaultText} translationId={defaultTranslationId} />
  )

  return (
    <LabeledItem
      labelId={`${id}-label`}
      showContent={hasTexts || defaultTextContent !== undefined}
      {...labelProps}
    >
      {texts &&
        texts.map((text: MaybeStringOrNumber, index: number) => (
          <TextContent
            id={texts.length > 1 ? `${id}-${index}` : id}
            key={'labeled-text-' + index}
            text={text}
          />
        ))}
      {textTranslationIds &&
        textTranslationIds.map((translationId: string, index: number) => (
          <TextContent
            id={textTranslationIds.length > 1 ? `${id}-${index}` : id}
            key={'labeled-text-' + index}
            translationId={translationId}
          />
        ))}
      {defaultTextContent}
    </LabeledItem>
  )
}
